import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { DocumentCommandBarItemProps, overflowButtonStyles, visibleButtonStyles } from './DocumentCommandBar'
import { DocumentContext, IDefaultFolderDto, IDocumentStackItemDto, isFolder } from '../../../config/documentConfig'
import { CommandBarButton } from '@fluentui/react'
import OfficeDocumentDialog from '../../Dialog/OfficeDocument/OfficeDocumentDialog'
import DialogButton from '../../Button/DialogButton'
import { DocumentType } from '../../../config/documentConfig'
import { useSettings } from '../../../hooks/useSettings'
import { useTranslation } from 'react-i18next'
import { getApplicationIconPropsByType } from '../../../helpers/iconHelper'

type Props = DocumentCommandBarItemProps & {
    name: string
}

export default function OfficeDocumentButton(props: Props): ReactElement {
    const { settings } = useSettings()
    const selectedFolder = props.selectedItems.find(isFolder)
    const { t: translate } = useTranslation()

    const disabled = useMemo(() => {
        const isExcluded =
            selectedFolder &&
            (settings?.folders || [])
                .filter((folder: IDefaultFolderDto) => folder.excluded)
                .map((folder: IDefaultFolderDto) => folder.label.toLowerCase())
                .find((search: string) => selectedFolder.name.toLowerCase().indexOf(search) !== -1)

        return props.isLoading || !!isExcluded
    }, [props.isLoading, settings?.folders, selectedFolder])

    return (
        <DialogButton
            button={CommandBarButton}
            buttonProps={{
                disabled,
                iconProps: getApplicationIconPropsByType(props.name.toUpperCase() as DocumentType),
                styles: props.item.renderedInOverflow ? overflowButtonStyles : visibleButtonStyles,
            }}
            dialog={OfficeDocumentDialog}
            dialogProps={{
                dialogContentProps: {
                    title: translate(`file.pivot.document.create.${props.name.toLowerCase()}`),
                },
                context: DocumentContext.Document,
                documentType: DocumentType[props.name],
                selectedFolder,
                folders: props.rootFolder.data,
                reset: (stack?: IDocumentStackItemDto[]) => props.reset(props.sortOrder, stack),
                variables: { file: props.file },
            }}
            tooltipProps={{ content: translate(`file.pivot.document.create.${props.name.toLowerCase()}`) }}
        />
    )
}
